import { Field } from "formik";
import { registerWidget } from "./registry";

const DropdownListInput = (props: any) => {
  return (
    <select
      key={props.key ?? props.id}
      id={props.id}
      name={props.id}
      className="form-control"
      style={{ marginBottom: "8px" }}
      value={props.value}
      title={props.label ?? props.name}
      onChange={(e) => {
        props.form.setFieldValue(props.id, parseInt(e.target.value));
      }}
    >
      {props.children.map(({ props: { value, children: text } }: any, index: number) => (
        <option value={value} key={index}>
          {text}
        </option>
      ))}
    </select>
  );
};

export const optionFormField = (config: any, formikParams: any) => {
  const extraProps = config ?? {};
  if (formikParams.handleChange != null)
    extraProps["onChange"] = formikParams.handleChange;
  if (formikParams.readOnly != null)
    extraProps["readOnly"] = formikParams.readOnly;
  return (
    <Field
      {...extraProps}
      component={DropdownListInput}
      name={config.name}
      type={"option"}
      className="form-control"
      id={config.name}
      label={config.label}
      as="select">
      {(typeof config.options === "function" ? config.options(formikParams) : config.options).map((x: any) => <option value={x.key} key={x.key}>{x.text ?? x.key}</option>)}
    </Field>
  );
};

registerWidget("option", optionFormField);
